import * as React from "react";
import { useState, useEffect } from "react";
function useLocalStorage(key, initialValue, shouldRemove = (v) => v === null) {
  const [value, setValue] = useState(() => {
    try {
      if (globalThis.localStorage.hasOwnProperty(key)) {
        const item = globalThis.localStorage.getItem(key);
        if (item !== null) {
          return JSON.parse(item);
        }
      }
    } catch (err) {
    }
    return initialValue;
  });
  React.useDebugValue(value, (v) => ({ key, value: v }));
  useEffect(() => {
    try {
      shouldRemove(value) ? globalThis.localStorage.removeItem(key) : globalThis.localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
    }
  }, [key, value, shouldRemove]);
  return React.useMemo(() => [value, setValue], [value, setValue]);
}
export {
  useLocalStorage
};
//# sourceMappingURL=use-local-storage.js.map
